import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiTrash2, FiSearch, FiCalendar, FiPlus, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, push, onValue, remove, update } from 'firebase/database';

const HSNInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [viewMode, setViewMode] = useState('list'); // 'list' or 'form'
    const [searchTerm, setSearchTerm] = useState('');
    const [hsnList, setHsnList] = useState([]);

    const initialFormState = {
        hsnNo: '',
        taxRate: '',
        isCess: false,
        cessRate: '',
        details: ''
    };
    const [formData, setFormData] = useState(initialFormState);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // Fetch Data
    useEffect(() => {
        const hsnRef = ref(database, 'Grampanchayat/Panipuravtha/HSNInfo');
        onValue(hsnRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setHsnList(loaded);
        });
    }, []);

    const handleSave = () => {
        if (!formData.hsnNo) {
            alert('कृपया HSN नंबर भरा');
            return;
        }

        const hsnRef = ref(database, 'Grampanchayat/Panipuravtha/HSNInfo');

        if (isEditing && selectedId) {
            const itemRef = ref(database, `Grampanchayat/Panipuravtha/HSNInfo/${selectedId}`);
            update(itemRef, formData)
                .then(() => {
                    alert('माहिती यशस्वीरित्या बदलली');
                    resetForm();
                })
                .catch(err => alert(err.message));
        } else {
            push(hsnRef, formData)
                .then(() => {
                    alert('माहिती यशस्वीरित्या साठवली');
                    resetForm();
                })
                .catch(err => alert(err.message));
        }
    };

    const handleEdit = (item) => {
        setFormData(item);
        setSelectedId(item.id);
        setIsEditing(true);
        setViewMode('form');
    };

    const handleDelete = (id) => {
        if (window.confirm('तुम्ही खात्रीने हे रेकॉर्ड डिलीट करू इच्छिता?')) {
            remove(ref(database, `Grampanchayat/Panipuravtha/HSNInfo/${id}`));
        }
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setIsEditing(false);
        setSelectedId(null);
        setViewMode('list');
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-poppins">
            <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg border border-blue-900 overflow-hidden">
                {/* Header */}
                <div className="bg-blue-800 text-white p-4 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <button onClick={() => viewMode === 'form' ? resetForm() : navigate(-1)} className="bg-white/10 hover:bg-white/20 p-2 rounded-full mr-2"><FiArrowLeft /></button>
                        <h1 className="text-xl font-bold">HSN यादी</h1>
                    </div>
                    {viewMode === 'list' && (
                        <button onClick={() => setViewMode('form')} className="bg-green-600 px-6 py-1.5 rounded font-bold text-sm hover:bg-green-700 transition">नवीन</button>
                    )}
                </div>

                {viewMode === 'list' ? (
                    <div className="p-4">
                         <div className="flex gap-2 mb-4">
                            <input 
                                type="text" 
                                placeholder="शोधणे" 
                                className="flex-grow border p-2 rounded border-blue-300 focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button className="bg-green-600 text-white px-6 py-2 rounded font-bold hover:bg-green-700 transition">शोधणे</button>
                         </div>
                         
                         <div className="overflow-x-auto">
                             <table className="w-full text-sm text-center border-collapse">
                                <thead className="bg-[#2c5282] text-white">
                                    <tr>
                                        <th className="px-4 py-3 border-r border-blue-400">HSN No</th>
                                        <th className="px-4 py-3 border-r border-blue-400">कर दर</th>
                                        <th className="px-4 py-3 border-r border-blue-400">सेस आहे का</th>
                                        <th className="px-4 py-3 border-r border-blue-400">सेस दर</th>
                                        <th className="px-4 py-3 border-r border-blue-400">सविस्तर माहिती</th>
                                        <th className="px-4 py-3">पर्याय</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {hsnList.filter(h => h.hsnNo.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 ? (
                                        <tr><td colSpan="6" className="p-4 text-gray-500">No records found</td></tr>
                                    ) : (
                                        hsnList.filter(h => h.hsnNo.toLowerCase().includes(searchTerm.toLowerCase())).map((h, idx) => (
                                            <tr key={h.id} className="hover:bg-blue-50">
                                                <td className="p-3 border-r font-medium text-blue-800">{h.hsnNo}</td>
                                                <td className="p-3 border-r">{h.taxRate} %</td>
                                                <td className="p-3 border-r">{h.isCess ? 'होय' : 'नाही'}</td>
                                                <td className="p-3 border-r">{h.cessRate || '-'}</td>
                                                <td className="p-3 border-r text-left truncate max-w-xs">{h.details}</td>
                                                <td className="p-3 flex justify-center gap-2">
                                                    <button onClick={() => handleEdit(h)} className="text-blue-600 hover:text-blue-800"><FiEdit size={18} /></button>
                                                    <button onClick={() => handleDelete(h.id)} className="text-red-500 hover:text-red-700"><FiTrash2 size={18} /></button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                             </table>
                         </div>

                        {/* Pagination */}
                        <div className="bg-gradient-to-b from-blue-700 to-blue-900 p-2 mt-4 flex justify-center gap-1 rounded-sm">
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">|&lt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&lt;&lt;</button>
                             <button className="px-3 py-1 bg-teal-600 text-white rounded text-xs border border-teal-400 font-bold">1</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;&gt;</button>
                             <button className="px-3 py-1 bg-blue-600 text-white rounded text-xs border border-blue-400">&gt;|</button>
                             <select className="ml-2 py-0.5 px-1 rounded text-xs"><option>5</option></select>
                        </div>
                    </div>
                ) : (
                    <div className="p-8 md:px-20 bg-white">
                        <h2 className="text-lg font-bold text-gray-700 mb-6 border-b pb-2">HSN माहिती</h2>
                        <div className="space-y-6 max-w-3xl mx-auto">
                            
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">HSN ID:</label>
                                <div className="md:col-span-3">
                                    <input type="text" value="Auto Generated" disabled className="w-full p-2 border border-blue-300 rounded bg-gray-100" />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">HSN no:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="text" 
                                        placeholder="HSN नं. भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.hsnNo}
                                        onChange={(e) => setFormData({...formData, hsnNo: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">कर दर:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="number" 
                                        placeholder="कर दर भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.taxRate}
                                        onChange={(e) => setFormData({...formData, taxRate: e.target.value})}
                                    />
                                </div>
                            </div>

                             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                <label className="text-right text-gray-700 md:col-span-1">सेस आहे का.:</label>
                                <div className="md:col-span-3">
                                    <input 
                                        type="checkbox" 
                                        className="w-5 h-5 border border-blue-300 rounded focus:ring-blue-500 text-blue-600"
                                        checked={formData.isCess}
                                        onChange={(e) => setFormData({...formData, isCess: e.target.checked})}
                                    />
                                </div>
                            </div>

                            {formData.isCess && (
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center animate-fade-in-down">
                                    <label className="text-right text-gray-700 md:col-span-1">सेस दर:</label>
                                    <div className="md:col-span-3">
                                        <input 
                                            type="number" 
                                            placeholder="सेस दर भरा." 
                                            className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                            value={formData.cessRate}
                                            onChange={(e) => setFormData({...formData, cessRate: e.target.value})}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
                                <label className="text-right text-gray-700 md:col-span-1 pt-2">सविस्तर माहिती:</label>
                                <div className="md:col-span-3">
                                    <textarea 
                                        rows="3"
                                        placeholder="सविस्तर माहिती भरा." 
                                        className="w-full p-2 border border-blue-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500" 
                                        value={formData.details}
                                        onChange={(e) => setFormData({...formData, details: e.target.value})}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-center gap-4 mt-8 pt-4">
                                <button onClick={handleSave} className="bg-green-600 text-white px-8 py-2 rounded font-bold hover:bg-green-700 transition">साठविणे</button>
                                <button onClick={resetForm} className="bg-red-600 text-white px-8 py-2 rounded font-bold hover:bg-red-700 transition">रद्द करणे</button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HSNInfo;
